import { render, staticRenderFns } from "./CreateOrEditModal.vue?vue&type=template&id=37326f53"
import script from "./CreateOrEditModal.vue?vue&type=script&lang=ts"
export * from "./CreateOrEditModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports